export default function registerModalStore(Alpine) {
    Alpine.store('modal', {
      activeId: null,
      videoHtml: {},
  
      init() {
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-modal-target-id]');
  
          if (!trigger) {
            return;
          }
  
          const id = trigger.getAttribute('data-modal-target-id');
  
          if (!id) {
            return;
          }
  
          const encodedIframeHtml = trigger.getAttribute('data-video-iframe') || '';
          const iframeHtml = encodedIframeHtml ? this.decodeBase64(encodedIframeHtml) : '';
  
          this.open(id, iframeHtml);
        });
  
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.close();
          }
        });
      },
  
      decodeBase64(value) {
        try {
          return atob(value);
        } catch (error) {
          return '';
        }
      },
  
      open(id, iframeHtml = '') {
        if (!id) {
          return;
        }
  
        this.activeId = id;
        document.body.setAttribute('data-modal-active', 'true');
  
        if (iframeHtml) {
          this.videoHtml[id] = iframeHtml;
        }
  
        Alpine.nextTick(() => {
          this.openVideoPlayer(id);
        });
      },
  
      close() {
        if (!this.activeId) {
          return;
        }
  
        const id = this.activeId;
  
        this.closeVideoPlayer(id);
  
        this.activeId = null;
        this.videoHtml[id] = '';
  
        document.body.setAttribute('data-modal-active', 'false');
      },
  
      openVideoPlayer(id) {
        const modal = document.querySelector(`[data-modal-id="${id}"]`);
  
        if (!modal) {
          return;
        }
  
        const video = modal.querySelector(`.ec-b-video-${id}`);
  
        if (!video) {
          return;
        }
  
        const videoSrc = video.getAttribute('data-src');
  
        if (videoSrc) {
          video.setAttribute('src', videoSrc);
        }
      },
  
      closeVideoPlayer(id) {
        const modal = document.querySelector(`[data-modal-id="${id}"]`);
  
        if (!modal) {
          return;
        }
  
        const video = modal.querySelector(`.ec-b-video-${id}`);
  
        if (video) {
          video.setAttribute('src', '');
        }
      },
  
      isOpen(id) {
        return this.activeId === id;
      },
  
      getVideoHtml(id) {
        return this.videoHtml[id] || '';
      },
    });
  
    Alpine.store('modal').init();
  }